import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Component, signal, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/requests/auth.service';
import { CredentialsDTO } from '../../../core/models/auth';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { InstitutionResolverService } from '../../../core/services/institution-resolver.service';
import { InstitutionPublicDTO } from '../../../core/models';
import { CacheKeys, SessionKeys } from '../../../shared/constants/cache-keys';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CardModule, ButtonModule, InputTextModule, PasswordModule, ToastModule, FloatLabelModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private readonly institutionService = inject(InstitutionResolverService);
  loading: boolean = false;
  form: FormGroup;
  institution = signal<InstitutionPublicDTO | null>(null);

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly messageService: MessageService
  ) {
    this.form = this.fb.group({
      nickname: ['', Validators.required],
      password: ['', Validators.required],
    })
    
    this.institutionService.init();
    this.getInstitutionPublicDTO().subscribe({
      next: (institution) => {
        this.institution.set(institution);
      }
    });
  }

  getInstitutionPublicDTO(): Observable<InstitutionPublicDTO | null> {
    const institutionLocal = this.institutionService.getFromLocalStorage();
    console.log("Instituição do local: ", institutionLocal);

    if (institutionLocal != null) {
      console.log("Instituição final (Local): ", institutionLocal);
      return of(institutionLocal);
    }

    console.log("Pesquisando o institution no resolver...");
    const slug = this.institutionService.extractSlug();
    
    return this.institutionService.getInstitution(slug).pipe(
      tap(data => console.log("Instituição final (API): ", data))
    );
  }

  onSubmit(): void {
    this.loading = true;

    if (this.form.valid) {
      const model: CredentialsDTO = {
        nickname: this.form.value.nickname,
        password: this.form.value.password,
      };

      this.authService.authenticate(model).subscribe({
        next: (response) => {
          if (response?.accessToken) {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Login realizado com sucesso!',
              life: 3000,
            });
            sessionStorage.setItem(CacheKeys.USER_STORAGE_PREFIX + ':institutions', JSON.stringify(response.institutions));
            this.router.navigate(['/institution']);
          }
        },
        error: (error) => {
          this.loading = false;
          const errorMessage = error?.error?.message || 'Erro ao realizar login';
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: errorMessage,
            life: 5000,
          });
        },
      });
    }
  }
}
